import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { ISite } from '../../../../Store/sites.state/sites.model';
import { CMD_ACTIONS, CMD_TARGETS, CmdRouterService, IActionCmd } from '../../../../services/cmd-router.service';
import { DialogComSvc } from '../../../../services/modeless-com.service';
import { DialogRef } from '../../../../common/Forms/Dialog-types/dialog-ref';
import { DialogModel } from '../../../../common/Models/Dialog/dialog.model';
import { PlacemarksState } from '../../../../Store/placemarks.state/placemarks.state';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  CoordinatesType,
  ILocation,
  IPlacemark,
  TEMP_PLACEMARK_ICON,
  WEBGL_OBJECT_MODE
} from '../../../../Store/placemarks.state/placemarks.model';
import { GeneralLayerId, ILayer, LAYER_TYPES, LAYER_VISIBILITY } from '../../../../Store/layers.state/layers.model';
import { LibIconsService } from '../../../../services/lib-icons.service';
import { PlacemarkPreviewService } from '../../../../services/placemark-preview.service';
import { LayersState } from '../../../../Store/layers.state/layers.state';
import { ZonesState } from '../../../../Store/zones.state/zones.state';
import { IZone } from '../../../../Store/zones.state/zones.model';
import { IViewpoint } from '../../../../Store/viewpoints.state/viewpoints.model';
import { DEFAULT_ZOOM_LEVEL, ViewpointsHelper } from '../../../../Store/viewpoints.state/viewpoints.helper';
import { debounceAtEnd } from '../../../../helper';
import { UpdateCurrViewpointParameters } from '../../../../Store/app.state/app.actions';
import { SiteWhenPlacemarksAreVisible } from '../../../../Store/sites.state/sites.utils';
import { ContainersHelper } from '../webgl-container/containers-helper';
import { environment } from '../../../../../environments/environment';
import { ServerApi } from '../../../../services/api.services/server.api';
import { SessionApiSvc } from '../../../../services/api.services/session.api.svc';
import { StatusCommentsIcon } from '../../../../Store/discussions.state/discussions.model';
import { SetPlacemarksWithComments } from '../../../../Store/discussions.state/discussions.actions';
import { SingleSearchResult } from '../../side-bar.container/subMenus/search-res-menu/search-res-menu.component';
import { PlacemarksApiSvc } from '../../../../services/api.services/placemarks.api.svc';
import { cloneDeep } from 'lodash';
import { ApiTools } from '../../../../services/api.services/api.tools';
import { AppState } from '../../../../Store/app.state/app.state';
import { isNullOrUndefined } from '../../../../helper';
import { ObjectSiteValidatorService } from '../../../../services/object-site-validator.service';
import { DiscussionsState } from '../../../../Store/discussions.state/discussions.state';
import { SitesLoaderSvc } from '../../../../services/api.services/sites.loader.svc';
import { SCENE_MODE } from 'src/app/Store/app.state/app.model';
import { DynamicPlacemarkService } from 'src/app/services/dynamic-placemark.service';
import { PlacemarkClusterService } from 'src/app/services/placemark-cluster.service';
import { ChecklistPlacemarkBalloonComponent } from 'src/app/common/UI-Components/checklist-placemark-balloon/checklist-placemark-balloon.component';
import { DynamicPlacemarkComponent } from './dynamic-placemark/dynamic-placemark.component';

import { Map as MapTilerMap, MapStyle, config, Marker, Popup, MapMouseEvent, LngLatLike, NavigationControl, Offset } from '@maptiler/sdk';
import * as turf from '@turf/turf';
import { MarkerManager } from './MarkerManager';
import { ChecklistPlacemarkBalloonService } from 'src/app/tour-component/services/checklist-placemark-balloon.service';
import { ButtonInfo } from 'src/app/common/UI-Components/helperClasses/value-and-display.class';
import { SelectionBoxComponent } from 'src/app/common/UI-Components/selection-box/selection-box.component';
import { MultiplePlacemarksMenuComponent } from './multiple-placemarks-menu/multiple-placemarks-menu.component';
import { MapService } from 'src/app/services/map.service';
import { MultipleSitesMenuComponent } from './multiple-sites-menu/multiple-sites-menu.component';

const DEFAULT_SINGLE_PM_ZOOM_LEVEL: number = 20;
const PLACEMARK_SIZE: number = 32;
export const nonZoneGeneralPlacemarkLayerIds: number[] = [GeneralLayerId.ADDITIONAL_INFO_GROUP, GeneralLayerId.PANORAMIC, GeneralLayerId.QR_CODE];
const enum Z_INDEX_CONSTS {
  SITE = 100000,
  PLACEMARK,
  CURRENT_SITE,
  SEARCH_RESULT,
  EDIT_CREATE
}
@Component({
    selector: 'ins-maps-container',
    templateUrl: './maps-container.component.html',
    styleUrls: ['./maps-container.component.scss'],
    imports: [DynamicPlacemarkComponent, ChecklistPlacemarkBalloonComponent, SelectionBoxComponent, MultiplePlacemarksMenuComponent, MultipleSitesMenuComponent]
})
export class MapsContainerComponent implements OnChanges, OnDestroy {

  private _draggablePin: Marker;
  private readonly _sitesMarkers: Map<number, Marker> = new Map<number, Marker>();
  private readonly placemarkMarkers: Map<string, Marker> = new Map();
  private searchResultsMarkers: Map<string, Marker> = new Map();
  private tempPM: IPlacemark[] = [];
  private _rightClickLat: number;
  private readonly actionListeners: Map<string, (event: any) => void> = new Map<string, (event: any) => void>();
  private zoomLevel: number = 18;
  private readonly placemarkBasicVisibilityMap: Map<string, boolean> = new Map();
  private readonly RADIUS: number = 6371000;
  private readonly NEAR_DISTANCE_ZOOMLEVELL_2: number = 484548;
  private readonly DISTANCE_BETWEEN_PLACEMARKS_RATIO: number = 2;
  private infoWindow: Popup;
  private inMeasureMode: boolean = false;
  private readonly commentMarkers = new Map<string, Marker>();


  set rightClickLat(val: number) {
    this._rightClickLat = val;
  }
  get rightClickLat(): number {
    const temp = this._rightClickLat;
    this._rightClickLat = undefined;
    return temp;
  }

  private _dynamicPlacemarkHideTimeout: any;

  private _rightClickLng: number;
  set rightClickLng(val: number) {
    this._rightClickLng = val;
  }
  get rightClickLng(): number {
    const temp = this._rightClickLng;
    this._rightClickLng = undefined;
    return temp;
  }

  @Output() openContextMenu: EventEmitter<any> = new EventEmitter();
  @ViewChild('mapContent', {static: true}) _mapContent: ElementRef;
  @Input() sites: ISite[];
  @Input() activeSiteInfo: ISite;
  @Input() openedPanel: string;
  public lastOpenedPanel: string;
  newPlacemarks$: Observable<IPlacemark[]>;
  updatePlacemarks$: Observable<IPlacemark[]>;
  layers$: Observable<ILayer[]>;
  visibleZones$: Observable<IZone[]>;
  changedLayers$: Observable<ILayer[]>;
  logoutToggleIndex$: Observable<number>;
  getSelectedPlacemark$: Observable<IPlacemark>;

  public mapRef: MapTilerMap;
  private isMapInitialized = false;
  private pendingChanges: SimpleChanges = {};

  public sceneMode: SCENE_MODE;
  selectedMode$: Observable<SCENE_MODE>;

  public mapTypes: ButtonInfo[] = [];
  public selectedMapType: string = '';
  private popupOffsets = {'bottom': [0, -30], 'top': [0, -0]};
  constructor(private readonly cmdRouterSvc: CmdRouterService, private readonly dialogComSvc: DialogComSvc, public libIconSrv: LibIconsService, public store: Store,
              private readonly placemarkPreviewService: PlacemarkPreviewService, private readonly containersHelper: ContainersHelper, public serverApi: ServerApi,
              public sessionApiSvc: SessionApiSvc, public placemarksApiSvc: PlacemarksApiSvc, private readonly checklistPlacemarkService: ChecklistPlacemarkBalloonService,
              private readonly objectSiteValidatorService: ObjectSiteValidatorService, public sitesLoaderSvc: SitesLoaderSvc, private readonly dynamicPlacemarkService: DynamicPlacemarkService,
              private readonly placemarkClusterService: PlacemarkClusterService, private readonly mapService: MapService) {
    this.layers$ = this.store.select(LayersState.getVisiblityChangedLayers);
    this.visibleZones$ = this.store.select(ZonesState.getVisibleZones);
    this.changedLayers$ = this.store.select(LayersState.getChangedLayers);
    this.logoutToggleIndex$ = this.store.select(AppState.getLogoutToggleIndex);
    this.newPlacemarks$ = this.store.select(PlacemarksState.getPlacemarksByType(CoordinatesType.GIS, WEBGL_OBJECT_MODE.NEW));
    this.updatePlacemarks$ = this.store.select(PlacemarksState.getPlacemarksByType(CoordinatesType.GIS, WEBGL_OBJECT_MODE.UPDATED));
    this.getSelectedPlacemark$ = this.store.select(DiscussionsState.getSelectedPlacemark);
    this.selectedMode$ = this.store.select(AppState.getSelectedMode);
    this.logoutToggleIndex$.subscribe((index: number) => {
      if (index > 0) {
        if (this._sitesMarkers) {
          this._sitesMarkers.forEach((marker: Marker) => {
            this.removeMarker((marker as any).id);
          });
        }
      }
    });
    this.selectedMode$.subscribe((mode: SCENE_MODE) => {
      this.sceneMode = mode;
      this.updateDynamicPlacemarkProperties(this.placemarkMarkers);

      if (this.sceneMode === SCENE_MODE.Map && !this.isMapInitialized) {
        this.mapService.load().subscribe((res: any) => {
          this.initializeMap(res.mapAPIKey);
          this.mapService.mapLoaded.next(true);
          this.isMapInitialized = true;
          if (this.pendingChanges) {
            this.handleChanges(this.pendingChanges);
            this.pendingChanges = {};
          }
        });
      }
    });
  }

  private clearAllPlacemarks(): void {
    this.placemarkMarkers.forEach((marker: Marker, id: string) => {
      this.removePMMarker(id);
    });
    this.dynamicPlacemarkService.deleteAllPlacemarks();
    this.placemarkClusterService.clearClusterPlacemarks();
  }

  private initActionCmdHandler(): void {
    this.cmdRouterSvc.actionCmdListener$(CMD_TARGETS.MAP_MANAGER)
      .subscribe((actionCmd: IActionCmd) => {
        switch (actionCmd.action) {
          case CMD_ACTIONS.CLEAR_SCENE: {
            this.clearAllPlacemarks();
            break;
          }
          case CMD_ACTIONS.FIT: {
            this.resetZoom();
            break;
          }
          case CMD_ACTIONS.CREATE_EDIT_SITE_MODE: {
            const siteId: number = actionCmd.options['siteId'];
            const site: ISite = actionCmd.options['site'];
            if (siteId) {
              // for editing site mode
              const existingMarker: Marker = this._sitesMarkers.get(siteId);
              MarkerManager.setIcon(existingMarker, `${environment.baseHref}/assets/map/yellow.pin.site.map.indicator.png`, PLACEMARK_SIZE, PLACEMARK_SIZE);
              MarkerManager.setZIndex(existingMarker, Z_INDEX_CONSTS.EDIT_CREATE);
              this._draggablePin = existingMarker
              this._draggablePin.setDraggable(true);
              MarkerManager.setIcon(this._draggablePin, `${environment.baseHref}/assets/map/yellow.pin.site.map.indicator.png`, PLACEMARK_SIZE, PLACEMARK_SIZE);
              this._draggablePin.on('drag', (event: any) => {
                this.dialogComSvc.sendToActiveDialog({latitude: event.target.getLngLat().lat, longitude: event.target.getLngLat().lng});
              });
              const center: LngLatLike = [site.longitude, site.latitude];
              this.mapRef.setCenter(center);
              this.mapRef.setZoom(ViewpointsHelper.altitudeToZoom(92000));
            } else {
              // for new site mode
              this.createDraggableMarker(`${environment.baseHref}/assets/map/yellow.pin.site.map.indicator.png`, true, );
            }

            const dialogRef: DialogRef = actionCmd.options['dialogRef'];
            dialogRef.onChanges$().subscribe((data: DialogModel) => {
              // Update lat long when change the value in the text box.
              // The site needs to move on the map
              this.coordinatesChanged(data['latitude'], data['longitude']);
            });

            dialogRef.onClose$().subscribe((data: DialogModel) => {
              if (siteId) {
                // for editing site mode
                const existingMarker: Marker = this._sitesMarkers.get(siteId);
                if (data.userAction !== 'add') {
                  existingMarker.setLngLat([site.longitude, site.latitude]);
                }
                const isActiveSite: boolean = this.activeSiteInfo.id === siteId;
                const urlToSiteIcon = isActiveSite ? `${environment.baseHref}/assets/map/blue.pin.site.map.indicator.png` : `${environment.baseHref}/assets/map/red.pin.site.map.indicator.png`;
                MarkerManager.setIcon(existingMarker, urlToSiteIcon, PLACEMARK_SIZE, PLACEMARK_SIZE);
                MarkerManager.setZIndex(existingMarker, isActiveSite ? Z_INDEX_CONSTS.CURRENT_SITE : Z_INDEX_CONSTS.SITE);
                this.removeDraggableMarker(false);
              } else {
                // for new site mode
                this.removeDraggableMarker(true);
              }
            });
            break;
          }
          case CMD_ACTIONS.DELETE_SITE: {
            const siteId: number = actionCmd.options['siteId'];
            this.removeMarker(siteId);
            break;
          }
          case CMD_ACTIONS.DELETE_PM: {
            const pmId: string = actionCmd.options['pmId'];
            this.removePMMarker(pmId);
            this.dynamicPlacemarkService.deletePlacemark(pmId);
            break;
          }
          case CMD_ACTIONS.COORDINATES_CHANGED: {
            this.coordinatesChanged(actionCmd.options['latitude'], actionCmd.options['longitude']);
            break;
          }

          case CMD_ACTIONS.VP_NEW_EDIT_MODE: {
            const dialogRef: DialogRef = actionCmd.options['dialogRef'];
            this.applyMapViewpointChangesListener(true);
            dialogRef.onClose$().subscribe((data: DialogModel) => {
              // get out of the listen change mode
              this.applyMapViewpointChangesListener(false);
            });
            break;
          }
          case CMD_ACTIONS.GO_TO_VP_MODE: {
            const vp: IViewpoint = actionCmd.options['selectedVP'];
            if (vp !== undefined) {
              if (vp.coordinatesType === CoordinatesType.GIS) {
                const lat: number = actionCmd.options['lat'];
                const lng: number = actionCmd.options['lng'];
                if (!isNullOrUndefined(lat) && !isNullOrUndefined(lng)) {
                  this.goToViewpoint(lat, lng, DEFAULT_ZOOM_LEVEL);
                } else {
                  this.goToViewpoint(vp.latitude, vp.longitude, ViewpointsHelper.altitudeToZoom(vp.altitude));
                }
              }
            }
            break;
          }
          case CMD_ACTIONS.CREATE_PLACEMARK: {
            const newMode: boolean = actionCmd.options['newMode'];
            const pmId: string = actionCmd.options['pmId'];
            this.createDraggableMarker(environment.windowOrigin + '/' + TEMP_PLACEMARK_ICON, newMode, pmId);

            const lat = this.rightClickLat;
            const lng = this.rightClickLng;
            if (lat != null && lng != null) {
              this.dialogComSvc.sendToActiveDialog({latitude: lat, longitude: lng});
              this.coordinatesChanged(lat, lng);
            }
            const dialogRef: DialogRef = actionCmd.options['dialogRef'];
            dialogRef.onChanges$().subscribe((data: DialogModel) => {
              if ((data['latitude']  && !isNaN(Number(data['latitude']))) || (data['longitude'] && !isNaN(Number(data['longitude'])))) {
                this.coordinatesChanged(data['latitude'], data['longitude']);
              } else if (data['name']) {
                this.setTitleForDraggable(data['name']);
              } else if (data['layerId']) {
                this.setIconForDraggable(this.getPlacemarkIconForLayer(data['layerId']));
              }
            });
            dialogRef.onClose$().subscribe((data: DialogModel) => {
              if (data.userAction === 'cancel' && !newMode) {
                const beforeUpdatePMlocationProperty: ILocation = actionCmd.options['location'];
                this.coordinatesChanged(beforeUpdatePMlocationProperty.latitude, beforeUpdatePMlocationProperty.longitude);
                const oldPm: IPlacemark  = actionCmd.options['oldPm'];
                if (oldPm != null) {
                  this.setTitleForDraggable(oldPm.name);
                  if (!oldPm.loadedOnDemand) {
                    const imageURL: string = this.getPlacemarkIconForLayer(oldPm.parentLayerId, oldPm);

                    // If we in discussion panel and edit PM that have discussion and cancel the edit, we need to comeback to the discussion PM icon
                    if (this.openedPanel === '' && this.lastOpenedPanel === 'sidebar.discussion') {
                      let statusIconUrl: string;
                      this.getSelectedPlacemark$.subscribe((pmId: IPlacemark) => {
                        const isSelectedPlacemark: boolean = pmId.id === oldPm.id;

                        if (isSelectedPlacemark) {
                          if (oldPm.statusType === 'STATUS' || oldPm.statusType === 'CHECKLIST') {
                            statusIconUrl =
                              imageURL.substring(0, imageURL.lastIndexOf('.')) + StatusCommentsIcon.COMMENTS_SELECTED;
                          } else {
                            statusIconUrl =
                              imageURL.substring(0, imageURL.lastIndexOf('/') + 1) + StatusCommentsIcon.STATUS + StatusCommentsIcon.COMMENTS_SELECTED
                              + imageURL.substring(imageURL.indexOf('?'));
                          }
                        } else if (oldPm.statusType === 'STATUS' || oldPm.statusType === 'CHECKLIST') {
                          statusIconUrl =
                            imageURL.substring(0, imageURL.lastIndexOf('.')) + StatusCommentsIcon.COMMENTS;
                        } else {
                          statusIconUrl =
                            imageURL.substring(0, imageURL.lastIndexOf('/') + 1) + StatusCommentsIcon.STATUS + StatusCommentsIcon.COMMENTS
                            + imageURL.substring(imageURL.indexOf('?'));
                        
                        }

                        this.setIconForDraggable(statusIconUrl);
                      }).unsubscribe();

                    } else {
                      this.setIconForDraggable(imageURL);
                    }

                  }
                }
                this.updateDynamicPlacemarkProperties(this.placemarkMarkers);
              }

              this.removeDraggableMarker(newMode);
            });
            break;
          }
          case CMD_ACTIONS.GO_TO_PM_MODE: {
            if (actionCmd.options['latitude'] || actionCmd.options['longitude']) {
              this.coordinatesChanged(actionCmd.options['latitude'], actionCmd.options['longitude']);
            }
            break;
          }
          case CMD_ACTIONS.CLOSE_MAP_INFO_WINDOW: {
            this.removeInfoWindow();
            break;
          }
          case CMD_ACTIONS.FILL_VIEWPOINT_PROPERTIES : {
            const center: LngLatLike = this.mapRef.getCenter();
            const params: any = {
              parent: 'MAPS',
              coordinatesType: 'GIS',
              latitude: center.lat,
              longitude: center.lng,
              altitude: ViewpointsHelper.zoomToAltitude(this.mapRef.getZoom()),
            };
            this.store.dispatch(new UpdateCurrViewpointParameters(params));
            break;
          }
          case CMD_ACTIONS.DISPLAY_PM_COMMENTS_ICONS: { // Change placemark icon for discussion panel
            const placemarkToEdit: IPlacemark = actionCmd.options['placemarkEdit'];
            const isSelectedPlacemark: boolean = actionCmd.options['isSelectedPlacemark'];
            this.showPlacemarkCommentsIcon(placemarkToEdit, isSelectedPlacemark);
            break;
          }
          case CMD_ACTIONS.CANCEL_DISPLAY_PM_COMMENTS_ICONS: { // Cancel changed placemark icon for discussion panel
            const placemarksWithComments: Map<string, string> = actionCmd.options['placemarksWithComments'];
            this.cancelCommentIconOnPlacemark(placemarksWithComments);
            break;
          }
          case CMD_ACTIONS.SHOW_SEARCH_RESULTS: {
            const searchResults: SingleSearchResult[] = actionCmd.options['searchResults'];
            this.addSearchResultPlacemarks(searchResults);
            break;
          }
          case CMD_ACTIONS.CENTER_SEARCH_RESULT: {
            const lat: number = actionCmd.options['lat'];
            const lng: number = actionCmd.options['lng'];
            this.goToViewpoint(lat, lng, DEFAULT_SINGLE_PM_ZOOM_LEVEL);
            break;
          }
          case CMD_ACTIONS.REMOVE_SEARCH_RESULTS: {
            this.removeSearchPMMarkers();
            break;
          }
          case CMD_ACTIONS.OPEN_CENTER_SEARCH_RESULT: {
            const pm: IPlacemark = actionCmd.options['pm'];
            this.showPlacemarkContent(pm);
            break;
          }
          case CMD_ACTIONS.MEASURE: {
            this.startMeasurementMode();
            break;
          }
          case CMD_ACTIONS.REMOVE_LAST_ACTIVE_PANEL: {
            this.lastOpenedPanel = undefined;
            break;
          }
          case CMD_ACTIONS.CLOSE_ACTIVE_PANEL: {
            this.lastOpenedPanel = this.openedPanel;
            break;
          }
          case CMD_ACTIONS.OPEN_PLAEMARK: {
            const marker: IPlacemark = actionCmd.options['marker'];
            const currentMarkerId: string = MarkerManager.getAttr(marker, 'id');
            const placemarks: IPlacemark[] = this.store.selectSnapshot<IPlacemark[]>((state: any) => state.StatePlacemarks.placemarks);
            const origPm: IPlacemark = placemarks.find((pm: IPlacemark) => pm.id === MarkerManager.getAttr(marker, 'id'));
            this.showPlacemarkContentFromMultipleMenu(currentMarkerId);
            this.onPlacemarkMarkerHover(false, origPm, marker, true);
            this.hideMenus();
            break;
          }

          case CMD_ACTIONS.OPEN_CONTEXT_MENU: {
            const event: any = actionCmd.options['event'];
            const marker: IPlacemark = actionCmd.options['marker'];
            const placemarks: IPlacemark[] = this.store.selectSnapshot<IPlacemark[]>((state: any) => state.StatePlacemarks.placemarks);
            const origPm: IPlacemark = placemarks.find((pm: IPlacemark) => pm.id === MarkerManager.getAttr(marker, 'id'));
            event.preventDefault();
            const latLng: LngLatLike = [origPm.location.longitude, origPm.location.latitude];

            this.rightClickLng = latLng[0];
            this.rightClickLat = latLng[1];

            const boundingBox =  event.currentTarget.getBoundingClientRect()
            this.openContextMenu.emit({x: boundingBox.left + boundingBox.width - 60,
              y: boundingBox.top - boundingBox.height + 5, placemarkId: origPm.id
            });
            break;
          }

          case CMD_ACTIONS.MULTIPLE_PLACEMARK_MENU_ITEM_HOVER: {
            const hover: boolean = actionCmd.options['hover'];
            const event: any = actionCmd.options['event'];
            const marker: IPlacemark = actionCmd.options['marker'];
            const placemarks: IPlacemark[] = this.store.selectSnapshot<IPlacemark[]>((state: any) => state.StatePlacemarks.placemarks);
            const origPm: IPlacemark = placemarks.find((pm: IPlacemark) => pm.id === MarkerManager.getAttr(marker, 'id'));

            if (hover) {
              const element = (event.target as HTMLInputElement).parentElement;
              const positionX = element.getBoundingClientRect().right - 60;
              const positionY = element.getBoundingClientRect().top - 50;
                this.onPlacemarkMarkerHover(true, origPm, marker, true, positionX, positionY);
            } else {
              this.onPlacemarkMarkerHover(false, origPm, marker, true);
            }
            break;
          }
          case CMD_ACTIONS.OPEN_SITE: {
            const marker: IPlacemark = actionCmd.options['marker'];
            const currentMarkerId: string = MarkerManager.getAttr(marker, 'id');
            const selectedSite: ISite = this.sites.find((siteInLoop: ISite) => siteInLoop.id === Number(currentMarkerId));
            const isSiteLoaded = this.activeSiteInfo ? this.activeSiteInfo.id === selectedSite.id : false;
            if (isSiteLoaded) {
              this.sitesLoaderSvc.toggleSceneMode(SCENE_MODE.Facility);
            } else {
              this.sitesLoaderSvc.loadSite(selectedSite);
            }            
            break;
          }
        }
      });
  }

  private startMeasurementMode(): void {
    this.inMeasureMode = true;
    const radius: number = 1609;
    const currentSite: ISite = this.sites.find((site: ISite) => site.id === +ApiTools.defaultSiteId);
    const origin: LngLatLike = [currentSite.longitude, currentSite.latitude];
    
    // Center the map on the current site when starting measurement mode
    this.mapRef.setCenter(origin);
    this.mapRef.setZoom(DEFAULT_ZOOM_LEVEL);
    
    const centerPoint = turf.point(origin);
    const circlePolygon = turf.circle(centerPoint, radius / 1000, { 
      steps: 64, 
      units: 'kilometers' 
    });

    this.mapRef.addSource('measure-circle', {
      type: 'geojson',
      data: circlePolygon
    });

    this.mapRef.addLayer({
      id: 'measure-circle-fill',
      type: 'fill',
      source: 'measure-circle',
      paint: {
        'fill-color': '#FF0000',
        'fill-opacity': 0.35
      }
    });
    
    this.mapRef.addLayer({
      id: 'measure-circle-stroke',
      type: 'line',
      source: 'measure-circle',
      paint: {
        'line-color': '#FF0000',
        'line-width': 2
      }
    });

    const startPoint = turf.point([currentSite.longitude, currentSite.latitude]);
    const offsetPoint = turf.destination(startPoint, radius / 1000, 90, { units: 'kilometers' });
    const markerPosition: LngLatLike = offsetPoint.geometry.coordinates as [number, number];

    // Create custom marker element for the icon
    const el = document.createElement('div');
    el.style.backgroundImage = `url(${environment.baseHref}/assets/map/red.dot.png)`;
    el.style.width = '20px';
    el.style.height = '20px';
    el.style.backgroundSize = 'cover';
    el.style.cursor = 'pointer';

    const dragMarker: Marker = new Marker({
      element: el,
      draggable: true
    }).setLngLat(markerPosition);
    dragMarker.addTo(this.mapRef);

    const popup = new Popup({ 
      closeButton: true,
      closeOnClick: false 
    }).setLngLat(markerPosition)
      .setHTML(`<div style="color: black;text-align:center; height:20px;width:70px">${Math.round(radius * 0.0621371) / 100.0} miles</div>`)
      .addTo(this.mapRef);

    const dragMarkerListener: any = dragMarker.on('drag', () => {
      const currPos: LngLatLike = dragMarker.getLngLat();
      const currentPoint = turf.point([currPos.lng, currPos.lat]);
      const originPoint = turf.point(origin);
      const dist: number = turf.distance(currentPoint, originPoint, { units: 'meters' });

      // Recreate circle with new radius (equivalent to circle.setRadius(dist))
      const newCirclePolygon = turf.circle(originPoint, dist / 1000, { 
        steps: 64, 
        units: 'kilometers' 
      });
      
      // Update the existing circle source with new data
      (this.mapRef.getSource('measure-circle') as any).setData(newCirclePolygon);
      popup.setLngLat(currPos);
      popup.setHTML(`<div style="color: black;text-align:center; height:20px;width:70px">${Math.round(dist * 0.000621371)} miles</div>`);
    });

    const closeClickListener = () => {
      if (this.mapRef.getLayer('measure-circle-fill')) {
        this.mapRef.removeLayer('measure-circle-fill');
      }
      if (this.mapRef.getLayer('measure-circle-stroke')) {
        this.mapRef.removeLayer('measure-circle-stroke');
      }
      if (this.mapRef.getSource('measure-circle')) {
        this.mapRef.removeSource('measure-circle');
      }
      dragMarker.remove();
      dragMarker.off('drag', dragMarkerListener);
      popup.off('close', closeClickListener);
      this.inMeasureMode = false;
    };
    popup.on('close', closeClickListener);

  }

  private cancelCommentIconOnPlacemark(placemarksWithComments: Map<string, string>): void {
    this.commentMarkers.forEach((marker, placemarkId) => {
      marker.remove();
      const originalMarker = this.placemarkMarkers.get(placemarkId);
      if (originalMarker) {
        MarkerManager.setAttr(originalMarker, 'commentIconUrl', null);
      }
    });
    this.commentMarkers.clear();
  }

  private showPlacemarkCommentsIcon(placemarkToEdit: IPlacemark, isSelectedPlacemark: boolean = false): void {
    const marker = this.placemarkMarkers.get(placemarkToEdit.id);
    if (marker) {
      let commentIconUrl: string;
      const imageURL: string = this.getPlacemarkIconForLayer(placemarkToEdit.parentLayerId, placemarkToEdit);
      this.store.dispatch(new SetPlacemarksWithComments(placemarkToEdit.id, imageURL));
      if (isSelectedPlacemark) {
        commentIconUrl = `${environment.baseHref}/assets/comments/comment_active.png`;
      } else {
        commentIconUrl = `${environment.baseHref}/assets/comments/comment.png`;
      }

      if (commentIconUrl) {
        const commentMarker: Marker = new Marker();
        MarkerManager.setZIndex(commentMarker, Z_INDEX_CONSTS.PLACEMARK + 1);
        MarkerManager.setIcon(commentMarker, commentIconUrl, 40, 40);
        commentMarker.setLngLat(marker.getLngLat());
        commentMarker.addTo(this.mapRef);
        
        // Forward click events from comment marker to underlying marker
        const commentElement = commentMarker.getElement();
        if (commentElement) {
          commentElement.addEventListener('click', (event) => {
            event.stopPropagation();
            const mainMarkerElement = marker.getElement();
            if (mainMarkerElement) {
              mainMarkerElement.click();
            }
          });
        }
        this.commentMarkers.set(placemarkToEdit.id, commentMarker);
        MarkerManager.setAttr(marker, 'commentIconUrl', commentIconUrl);
      }
    }
  }

  private getPlacemarkIconForLayer(layerId: string, pm?: IPlacemark): string {
    const layers: ILayer[] = this.store.selectSnapshot<ILayer[]>((state: any) => state.StateLayers.layers);
    const currentLayer = layers.find((layer: ILayer) => layer.id === layerId);
    let imageURL: string;

    if (currentLayer.layerType !== LAYER_TYPES.Status) {
      imageURL = currentLayer.libIconId ? this.libIconSrv.getLibIconUrlForScene(currentLayer.libIconId) : currentLayer.iconURL;
    } else if (pm) {
      imageURL = this.containersHelper.getStatusPMIcon(pm, currentLayer);
    } else {
      console.log('Strange situation- should be checked! Zvikaa');
      return '';
    }
    return imageURL;
  }

  private coordinatesChanged(_lat: number, _lng: number): void {
    const position: LngLatLike = this._draggablePin.getLngLat();
    const lat: number = _lat ?? position.lat;
    const lng: number = _lng ?? position.lng;
    this._draggablePin.setLngLat([lng, lat]);
  }

  private setTitleForDraggable(title: string): void {
    MarkerManager.setTitle(this._draggablePin, title);
  }

  private setIconForDraggable(iconUrl: string): void {
    MarkerManager.setIcon(this._draggablePin, iconUrl, PLACEMARK_SIZE, PLACEMARK_SIZE);
  }

  private applyMapViewpointChangesListener(listen: boolean): void {
    if (listen) {
      // Send initial data for case if the map will not moved
      let center: LngLatLike = this.mapRef.getCenter();
      this.dialogComSvc.sendToActiveDialog({x_coord: center.lat, y_coord: center.lng});
      this.dialogComSvc.sendToActiveDialog({z_coord: this.mapRef.getZoom()});

      const centerChangedListener = () => {
        const center = this.mapRef.getCenter();
        this.dialogComSvc.sendToActiveDialog({x_coord: center.lat, y_coord: center.lng});
      };

      this.mapRef.on('move', centerChangedListener);
      this.actionListeners.set('editVp_centerChanged', centerChangedListener);

      const zoomChangedListener = () => {
        this.dialogComSvc.sendToActiveDialog({z_coord: this.mapRef.getZoom()});
      };
      this.mapRef.on('zoom', zoomChangedListener);
      this.actionListeners.set('editVp_zoomChanged', zoomChangedListener);

    } else {
      let existingListener = this.actionListeners.get('editVp_centerChanged');
      if (existingListener !== undefined) {
        this.mapRef.off('move', existingListener);
        this.actionListeners.delete('editVp_centerChanged');
      }
      existingListener = this.actionListeners.get('editVp_zoomChanged');
      if (existingListener !== undefined) {
        this.mapRef.off('zoom', existingListener);
        this.actionListeners.delete('editVp_zoomChanged');
      }
    }
  }

  private addSitesMarkers(sites: ISite[]): void {
    sites.forEach((site: ISite) => {
      this.addSiteMarker(site);
    });
  }

  private convertMapCoordinatesToScreen(lngLat: LngLatLike): any {
    const point = this.mapRef.project(lngLat);
    return { x: point.x, y: point.y };
  }

  private convertScreenCoordinatesToMap(x: number, y: number): LngLatLike { 
    const lngLat = this.mapRef.unproject([x, y]);
    return [lngLat.lng, lngLat.lat];
  }

  private getZoomlevelDistance(): number {
    let dist: number = 0;
    let tempDist: number = this.NEAR_DISTANCE_ZOOMLEVELL_2;
    for (let i: number = 2; i < this.mapRef.getZoom(); i++) {
      dist = tempDist / this.DISTANCE_BETWEEN_PLACEMARKS_RATIO;
      tempDist = dist;
    }
    return Math.round(dist);
  }

  public changeMapType(selectedType: string): void {
    this.selectedMapType = selectedType;
    this.mapRef.setStyle(selectedType);
  }

  private initializeMap(apiKey: string): void {
    config.apiKey = apiKey;
    this.mapTypes = [
      new ButtonInfo(MapStyle.BASIC, 'Basic'),
      new ButtonInfo(MapStyle.SATELLITE, 'Satellite'),
      new ButtonInfo(MapStyle.STREETS, 'Streets'),
      new ButtonInfo(MapStyle.OUTDOOR, 'Outdoor'),
      new ButtonInfo(MapStyle.WINTER, 'Winter'),
      new ButtonInfo(MapStyle.HYBRID, 'Hybrid'),
      new ButtonInfo(MapStyle.BRIGHT, 'Bright'),
      new ButtonInfo(MapStyle.DATAVIZ, 'Dataviz'),
      new ButtonInfo(MapStyle.TOPO, 'Topo'),
      new ButtonInfo(MapStyle.VOYAGER, 'Voyager'),
      new ButtonInfo(MapStyle.TONER, 'Toner'),
      new ButtonInfo(MapStyle.BACKDROP, 'Backdrop'),
      new ButtonInfo(MapStyle.OPENSTREETMAP, 'OpenStreetMap'),
    ];

    this.selectedMapType = this.mapTypes[0].value;

    this.mapRef = new MapTilerMap({
      container: this._mapContent.nativeElement,
      style: this.selectedMapType,
      center: [0, 0],
      zoom: 2,
      fullscreenControl: false,
      navigationControl: false,
      geolocateControl: false,
      attributionControl: false,
    });

    this.mapRef.on('load', () => {
      this.mapRef.addControl(new PanControl(), 'bottom-right');
      this.mapRef.addControl(new NavigationControl({
        showCompass: false,
      }), 'bottom-right');
    });

    this.placemarkClusterService.init(this.mapRef, this.placemarkMarkers);

    this.initMapsGeneralListeners();
    this.initActionCmdHandler();
    this.setPlacemarksOnMap();
    this.setLayersVisibility();
    this.setZonesVisibility();
    this.registerUpdatePlacemark();
  }

  updatePlacemarksVisibility(): void {
    const isVisible: boolean = this.mapRef.getZoom() >= this.zoomLevel;
    this.placemarkMarkers.forEach((marker: Marker, id: string) => {
      const visibility: boolean = isVisible && this.placemarkBasicVisibilityMap.get(id);
      MarkerManager.setVisible(marker, visibility);
      const placemark = {placemarkId: id, visible: visibility};
      this.dynamicPlacemarkService.updatePlacemarkVisibility(placemark);
    });
    this.placemarkClusterService.placemarkVisibilityUpdated();
  }

  initMapsGeneralListeners(): void {
    this.mapRef.on('drag',  this.throttleFunction(() => {
      this.updateDynamicPlacemarkProperties(this.placemarkMarkers);
      this.hideMenus();
    }, 100/30));

    addEventListener("resize", (event) => setTimeout(() => this.updateDynamicPlacemarkProperties(this.placemarkMarkers), 100));

    this.mapRef.on('contextmenu', (event: MapMouseEvent) => {
      event.preventDefault();
      this.removeInfoWindow();
      const screenCoordinates: any = this.convertMapCoordinatesToScreen(event.lngLat);
      this.openContextMenu.emit({x: screenCoordinates.x, y: screenCoordinates.y});
      this.rightClickLng = event.lngLat.lng;
      this.rightClickLat = event.lngLat.lat;
      this.hideMenus();
    });
    this.mapRef.on('click', (event) => {
      this.removeInfoWindow();
      this.hideMenus();
      this.showDynamicPlacemarkOnHover(false, null, null);
      this.hideChecklistPlacemarkContent(null);
    });
    this.mapRef.on('zoom', (event) => {
     this.updateDynamicPlacemarkProperties(this.placemarkMarkers);
      this.throttledZoomHandler();
      this.hideMenus();
    });
    this.mapRef.on('moveend', debounceAtEnd(() => {
      const center: LngLatLike = this.mapRef.getCenter();
      const params: any = {
        parent: 'MAPS',
        coordinatesType: 'GIS',
        latitude: center.lat,
        longitude: center.lng,
        altitude: ViewpointsHelper.zoomToAltitude(this.mapRef.getZoom()),
      };
      this.store.dispatch(new UpdateCurrViewpointParameters(params));
      this.updateDynamicPlacemarkProperties(this.placemarkMarkers);
      this.hideMenus();
    }, 400));
  }

  
  private throttledZoomHandler = this.throttleFunction(() => {
    this.updatePlacemarksVisibility();
  }, 2000);

  setLayersVisibility(): void {
    this.layers$.subscribe((layers: ILayer[]) => {
      const zones: IZone[] = this.store.selectSnapshot<IZone[]>((state: any) => state.StateZones.zones);
      if (this.tempPM.length > 0) {
        this.handleTempPlacemarks(zones, layers);
      } else {
        this.handlePlacemarks(zones, layers);
      }
    });

    this.changedLayers$.subscribe((changedLayers: ILayer[]) => {
      const placemarks: IPlacemark[] = this.store.selectSnapshot<IPlacemark[]>((state: any) => state.StatePlacemarks.placemarks);
      changedLayers.forEach((layer: ILayer) => {
        if  (layer.layerType === LAYER_TYPES.Status) {
          const changedPlacemarks: IPlacemark[] = placemarks.filter((pm: IPlacemark) => pm.parentLayerId === layer.id);
          changedPlacemarks.forEach((pm: IPlacemark) => {
            if (pm.coordinatesType === CoordinatesType.GIS) {
              const imageURL: string = this.containersHelper.getStatusPMIcon(pm, layer);
              const marker = this.placemarkMarkers.get(pm.id);
              MarkerManager.setIcon(marker, imageURL, PLACEMARK_SIZE, PLACEMARK_SIZE);
              this.placemarkMarkers.set(pm.id, marker);
            }
          });
          this.dynamicPlacemarkService.updatePlacemarkOnLayerUpdate(layer.id, layer.visualizationMethod, layer.visualizationConf);
        }
      });
    });
  }
  setZonesVisibility(): void {
    this.visibleZones$.subscribe((zones: IZone[]) => {
      const layers: ILayer[] = this.store.selectSnapshot<ILayer[]>((state: any) => state.StateLayers.layers);
      if (this.tempPM.length > 0) {
        this.handleTempPlacemarks(zones, layers);
      } else {
        this.handlePlacemarks(zones, layers);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.isMapInitialized) {
      for (const prop in changes) {
        if (!changes.hasOwnProperty(prop)) { continue; }
        this.pendingChanges[prop] = changes[prop];
      }
      return;
    }
    this.handleChanges(changes);
  }

  private handleChanges(changes: SimpleChanges): void {
    if (changes.activeSiteInfo?.currentValue != null) {
      if (changes.activeSiteInfo.currentValue.placemarkClustering != null) {
        this.placemarkClusterService.setPlacemarkClustering(changes.activeSiteInfo.currentValue.placemarkClustering);
      }
      const { latitude, longitude } = MarkerManager.adjustInvalidCoordinates(this.activeSiteInfo.latitude, this.activeSiteInfo.longitude);
      this.activeSiteInfo.latitude = latitude;
      this.activeSiteInfo.longitude = longitude;
      
      switch (this.activeSiteInfo.placemarkLOD) {
        case SiteWhenPlacemarksAreVisible.Always: {
          this.zoomLevel = 0;
          break;
        }
        case SiteWhenPlacemarksAreVisible.Close: {
          this.zoomLevel = 20;
          break;
        }
        case SiteWhenPlacemarksAreVisible.Far: {
          this.zoomLevel = 16;
          break;
        }
        case SiteWhenPlacemarksAreVisible.Intermediate: {
          this.zoomLevel = 18;
          break;
        }
      }
    }
    if (changes.openedPanel) {
      if (this.openedPanel !== 'sidebar.search') {
        this.hideSearchPMMarkers();
      } else {
        this.displaySearchPMMarkers();
      }
    }
    this.updatePlacemarksVisibility();
    if (this.sites && changes.sites) {
      this.addSitesMarkers(this.sites);
    }
  }

  public setPlacemarksOnMap(): void {
    this.newPlacemarks$.subscribe((pms: IPlacemark[]) => {
      const layers: ILayer[] = this.store.selectSnapshot<ILayer[]>((state: any) => state.StateLayers.layers);
      const zones: IZone[] = this.store.selectSnapshot<IZone[]>((state: any) => state.StateZones.zones);
      pms.forEach((pm: IPlacemark) => {
        if (this.objectSiteValidatorService.validateObjectToActiveSite(pm.id)) {
          this.tempPM.push(pm);
          this.handleTempPlacemarks(zones, layers);
        }

      });
    });
  }

  isPlacemarkVisible(pm: IPlacemark, layer: ILayer, zone: IZone): boolean {
    let visibility: boolean = false;
    let isNonZoneGeneralPlacemarkLayer = false;
    if (layer && nonZoneGeneralPlacemarkLayerIds.indexOf(Number(layer.id)) !== -1)  {
      isNonZoneGeneralPlacemarkLayer = true;
    }
    if ((!isNonZoneGeneralPlacemarkLayer && zone && zone.visible && layer && layer.visible === LAYER_VISIBILITY.VISIBLE) || (isNonZoneGeneralPlacemarkLayer && layer && layer.visible === LAYER_VISIBILITY.VISIBLE)) {
      visibility = true;
    }
    return visibility;
  }


  handlePlacemarks(zones: IZone[], layers: ILayer[]): void {
    const pmToEdit: IPlacemark[] = this.store.selectSnapshot<IPlacemark[]>((state: any) => state.StatePlacemarks.placemarks);
    pmToEdit.filter((pm: IPlacemark) => pm.coordinatesType === CoordinatesType.GIS && pm.objMode === WEBGL_OBJECT_MODE.IDLE)
      .forEach((pm: IPlacemark) => {
        const layer: ILayer = layers.find((layer1: ILayer) => layer1.id === pm.parentLayerId);
        if (layer != null) {
          let zone: IZone = zones.find((zone1: IZone) => zone1.id === pm.parentZoneId) || null;
          const marker = this.placemarkMarkers.get(pm.id);
          const {latitude, longitude} = MarkerManager.adjustInvalidCoordinates(pm.location.latitude, pm.location.longitude);
          marker.setLngLat([longitude, latitude]);
          MarkerManager.setTitle(marker, pm.name);
          const visibility: boolean = this.isPlacemarkVisible(pm, layer, zone);
          this.placemarkBasicVisibilityMap.set(pm.id, visibility);
          MarkerManager.setVisible(marker, visibility && this.mapRef.getZoom() >= this.zoomLevel);
          if (pm.statusType == 'STATUS' && pm.showVisualization) {
            const placemark = {placemarkId: pm.id, visible: visibility && this.mapRef.getZoom() >= this.zoomLevel};
            this.dynamicPlacemarkService.updatePlacemarkVisibility(placemark);
          }
          if (layer) {
            const iconUrl: string = this.getPlacemarkIconForLayer(layer.id, pm);
            MarkerManager.setIcon(marker, iconUrl, PLACEMARK_SIZE, PLACEMARK_SIZE);
          }
          MarkerManager.setZIndex(marker, Z_INDEX_CONSTS.PLACEMARK);
          this.placemarkMarkers.set(pm.id, marker);
        }
      });
      this.placemarkClusterService.placemarkVisibilityUpdated();
  }

  async addSearchResultPlacemarks(searchResults: SingleSearchResult[]): Promise<void> {
    if (this.openedPanel == 'sidebar.search') {
      this.removeSearchPMMarkers();
      for(const result of searchResults){
        await this.addSearchResultPlacemark(result);
      }
      if (this.searchResultsMarkers.size > 0) {
        const coordinates: [number, number][] = Array.from(this.searchResultsMarkers.values())
          .map(marker => {
            const lngLat = marker.getLngLat();
            return [lngLat.lng, lngLat.lat] as [number, number];
          });
        const lngs = coordinates.map(coord => coord[0]);
        const lats = coordinates.map(coord => coord[1]);
        
        const bounds: [[number, number], [number, number]] = [
          [Math.min(...lngs), Math.min(...lats)],
          [Math.max(...lngs), Math.max(...lats)]
        ];

        this.mapRef.fitBounds(bounds, { 
          padding: { top: 50, bottom: 50, left: 50, right: 50 }
        });
      }
    }
  }

  async addSearchResultPlacemark(searchResult: SingleSearchResult): Promise<void> {
    const placemarkMarker: Marker = new Marker();
    let id: string = searchResult.searchObjId;
    const { latitude, longitude } = MarkerManager.adjustInvalidCoordinates(searchResult.location.latitude, searchResult.location.longitude);
    placemarkMarker.setLngLat([longitude, latitude]);
    placemarkMarker.addTo(this.mapRef);
    if (searchResult.type === 'MAP_PLACE') {
      MarkerManager.setTitle(placemarkMarker, searchResult.name);
    } else {
      const placemarks: IPlacemark[] = this.store.selectSnapshot<IPlacemark[]>((state: any) => state.StatePlacemarks.placemarks);
      let origPm: IPlacemark = placemarks.find((pm: IPlacemark) => pm.id === searchResult.originalObjId);
      if (!origPm) {
        // we will get here if pm is part of unloaded Zone where we didn't load the placemark to store
        if(searchResult.type === "PLACE"){
          origPm = await this.placemarksApiSvc.getAddressPlacemarkById(searchResult.originalObjId);
        } else {
          origPm = await this.placemarksApiSvc.getPlacemarkById(searchResult.originalObjId, searchResult.type);
        }
      } else {
        origPm = cloneDeep(origPm);
      }
      MarkerManager.addEventListener(placemarkMarker, 'click', (event) => {
        event.stopPropagation();
        this.updatePlacemarkContent(origPm, placemarkMarker);
      });
      MarkerManager.addEventListener(placemarkMarker, 'contextmenu', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.handleRightClickEvent(event, origPm, placemarkMarker);
      });
      MarkerManager.setTitle(placemarkMarker, searchResult.name);
      // if there is exisitng marker, bind them together
      const origMarker: Marker = this.placemarkMarkers.get(searchResult.originalObjId);
      if (origMarker) {
         MarkerManager.bindTo(placemarkMarker, origMarker);
      }
      id = searchResult.originalObjId;
    }
    const iconUrl: string = `${environment.baseHref}/assets/search_panel/letters/placemarkResult64_${searchResult.letterIndex}.png`;
    MarkerManager.setIcon(placemarkMarker, iconUrl, PLACEMARK_SIZE, PLACEMARK_SIZE);
    MarkerManager.setZIndex(placemarkMarker, Z_INDEX_CONSTS.SEARCH_RESULT);
    MarkerManager.setAttr(placemarkMarker, 'id', searchResult.searchObjId);
    this.searchResultsMarkers.set(id, placemarkMarker);
  }

  registerUpdatePlacemark(): void {
    this.updatePlacemarks$.subscribe((pms: IPlacemark[]) => {
      pms.forEach((pm: IPlacemark) => {
        const marker = this.placemarkMarkers.get(pm.id);
        const {latitude, longitude} = MarkerManager.adjustInvalidCoordinates(pm.location.latitude, pm.location.longitude);
        marker.setLngLat([longitude, latitude]);
        MarkerManager.setTitle(marker, pm.name);
        MarkerManager.setZIndex(marker, Z_INDEX_CONSTS.PLACEMARK);
        this.placemarkClusterService.placemarkUpdated(marker);
        MarkerManager.setAttr(marker, 'previousPosition', marker.getLngLat());
        MarkerManager.removeEventListener(marker, 'click');
        MarkerManager.addEventListener(marker, 'click', (event) => {
          event.stopPropagation();
          this.updatePlacemarkContent(pm, marker);
        });

        const zone: IZone = this.store.selectSnapshot<IZone[]>((state: any) => state.StateZones.zones)
          .find((zone: IZone) => zone.id === pm.parentZoneId) || null;

        const layer: ILayer = this.store.selectSnapshot<ILayer[]>((state: any) => state.StateLayers.layers)
          .find((layer: ILayer) => layer.id === pm.parentLayerId);

        let visibility: boolean = this.isPlacemarkVisible(pm, layer, zone);

        this.placemarkBasicVisibilityMap.set(pm.id, visibility);
        MarkerManager.setVisible(marker, visibility && this.mapRef.getZoom() >= this.zoomLevel);
        const iconUrl: string = this.getPlacemarkIconForLayer(pm.parentLayerId, pm);

        this.handlePlacemarkInfoWindow(marker, pm, layer);

        MarkerManager.addEventListener(marker, 'mouseover', (event) => {
          this.onPlacemarkMarkerHover(true, pm, marker);
        });

        MarkerManager.addEventListener(marker, 'mouseout', (event) => {
          this.onPlacemarkMarkerHover(false, pm, marker);
        });

        if (this.openedPanel === 'sidebar.discussion') {
          let statusIconUrl: string;
          this.getSelectedPlacemark$.subscribe((pmId: IPlacemark) => {
            const isSelectedPlacemark: boolean = pmId.id === pm.id;

            if (!isSelectedPlacemark) {
              if (pm.statusType === 'STATUS' || pm.statusType === 'CHECKLIST') {
                statusIconUrl =
                  iconUrl.substring(0, iconUrl.lastIndexOf('.')) + StatusCommentsIcon.COMMENTS;
              } else {
                statusIconUrl =
                  iconUrl.substring(0, iconUrl.lastIndexOf('/') + 1) + StatusCommentsIcon.STATUS + StatusCommentsIcon.COMMENTS
                  + iconUrl.substring(iconUrl.indexOf('?'));
              }
            }
            MarkerManager.setIcon(marker, statusIconUrl, PLACEMARK_SIZE, PLACEMARK_SIZE);
          }).unsubscribe();

        } else {
          MarkerManager.setIcon(marker, iconUrl, PLACEMARK_SIZE, PLACEMARK_SIZE);
        }
        this.placemarkMarkers.set(pm.id, marker);
        this.updateDynamicPlacemark(cloneDeep(pm), marker);

      });
    });
  }

  handleTempPlacemarks(zones: IZone[], layers: ILayer[]): void {
    this.tempPM = this.tempPM.filter((pm: IPlacemark) => {
      const layer: ILayer = layers.find((layer1: ILayer) => layer1.id === pm.parentLayerId);
      if (!layer) {
        return true;
      }

      let zone: IZone = zones.find((zone1: IZone) => zone1.id === pm.parentZoneId) || null;

      this.addPlacemarkMarker(pm, layer, zone);
      return false;
    });
  }

  addPlacemarkMarker(pm: IPlacemark, layer: ILayer, zone: IZone): void {
    const placemarkMarker: Marker = new Marker();

    const {latitude, longitude} = MarkerManager.adjustInvalidCoordinates(pm.location.latitude, pm.location.longitude);
    placemarkMarker.setLngLat([longitude, latitude]);
      const iconUrl: string = this.getPlacemarkIconForLayer(layer.id, pm);
    MarkerManager.setIcon(placemarkMarker, iconUrl, PLACEMARK_SIZE, PLACEMARK_SIZE);
    placemarkMarker.addTo(this.mapRef);
    MarkerManager.addEventListener(placemarkMarker, 'click', (event) => {
      event.stopPropagation();
      this.updatePlacemarkContent(pm, placemarkMarker);
    });
    MarkerManager.addEventListener(placemarkMarker, 'contextmenu', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.handleRightClickEvent(event, pm, placemarkMarker);
    });

    MarkerManager.setAttr(placemarkMarker, 'previousPosition', placemarkMarker.getLngLat());
    MarkerManager.setAttr(placemarkMarker, 'type', pm.category);
    MarkerManager.setTitle(placemarkMarker, pm.name);

    const visibility: boolean = this.isPlacemarkVisible(pm, layer, zone);
    this.placemarkBasicVisibilityMap.set(pm.id, visibility);
    MarkerManager.setVisible(placemarkMarker, visibility && this.mapRef.getZoom() >= this.zoomLevel);
    MarkerManager.setZIndex(placemarkMarker, Z_INDEX_CONSTS.PLACEMARK);
    MarkerManager.setAttr(placemarkMarker, 'id', pm.id);
    this.placemarkMarkers.set(pm.id, placemarkMarker);
    this.handlePlacemarkInfoWindow(placemarkMarker, pm, layer);

    MarkerManager.addEventListener(placemarkMarker, 'mouseover', (event) => {
      this.onPlacemarkMarkerHover(true, pm, placemarkMarker);
    });

    MarkerManager.addEventListener(placemarkMarker, 'mouseout', (event) => {
      this.onPlacemarkMarkerHover(false, pm, placemarkMarker);
    })

    if (pm.statusType === 'STATUS') {
      if (pm.showVisualization) {
          if (pm.visualizationConf.visibilityType == 'iconAndvalues' || pm.visualizationConf.visibilityType == 'valuesOnCollapseIcon') {
              this.addDynamicPlacemark(cloneDeep(pm), placemarkMarker);
          }
      }
    }
    this.placemarkClusterService.placemarkCreated(placemarkMarker);
  }

  handlePlacemarkInfoWindow(placemarkMarker: Marker, pm: IPlacemark, layer: ILayer) {
    MarkerManager.removeEventListener(placemarkMarker, 'mouseover');
    MarkerManager.removeEventListener(placemarkMarker, 'mouseout');
    if (pm.statusType === 'CHECKLIST') {
      MarkerManager.addEventListener(placemarkMarker, 'mouseover', () => {
        const position = placemarkMarker.getLngLat();
        this.showCheckPlacemarklistContent(pm, layer, position);
      });

      MarkerManager.addEventListener(placemarkMarker, 'mouseout', (event) => {
        this.hideChecklistPlacemarkContent(event);
      });
    }
  }

  hideChecklistPlacemarkContent(event: Event): void {
    setTimeout(() => {
      this.checklistPlacemarkService.hideChecklistPlacemarkBolloon(event);
    }, 200);
  }

  showCheckPlacemarklistContent(pm: IPlacemark, layer: ILayer, position: LngLatLike, fromMultiplePlacemarkMenu = false): void {
    const screenCoordinates: any = this.convertMapCoordinatesToScreen(position);
    if (!fromMultiplePlacemarkMenu) {
      screenCoordinates.y = screenCoordinates.y - 15;
    }
    setTimeout(() => {
      this.checklistPlacemarkService.showChecklistPlacemarkBolloon(pm, layer, screenCoordinates, fromMultiplePlacemarkMenu);
    }, 200);
  }

  updatePlacemarkContent(pm: IPlacemark, placemarkMarker: Marker): void {
    if (this._draggablePin) {
      return;
    }
    this.removeInfoWindow();
    event.preventDefault();
    const isSearchPlacemark = MarkerManager.getAttr(placemarkMarker, 'id').includes('SEARCH_ENGINE_RESULT');
    const closestPlacemarks: Marker[] = this.getPlacemarksInRadius(pm, isSearchPlacemark);
    !isSearchPlacemark && closestPlacemarks.push(placemarkMarker);

    if (closestPlacemarks.length === 1) {
      this.showPlacemarkContent(pm);
    } else {
      this.showMultiplePlacemarkMenu(pm, placemarkMarker,closestPlacemarks);
    }
  }

  showMultiplePlacemarkMenu(pm, placemarkMarker: Marker, closestPlacemarks: Marker[]): void {
    closestPlacemarks.sort( (a, b) => this.getTitleForPlacemark(MarkerManager.getAttr(a, 'id')).localeCompare(this.getTitleForPlacemark(MarkerManager.getAttr(b, 'id'))));
    const position = this.convertMapCoordinatesToScreen(placemarkMarker.getLngLat());
    position.y = position.y - 15;
    this.mapService.setMultiplePlacemarkMenuOptions(closestPlacemarks, position);
  }

  getIconForPlacemark(markerId: string): string {
    return MarkerManager.getIcon(this.placemarkMarkers.get(markerId));
  }

  getTitleForPlacemark(markerId: string): string {
    return MarkerManager.getTitle(this.placemarkMarkers.get(markerId));
  }

  showPlacemarkContent(pm: IPlacemark): void {
    if (pm.category === 'PANORAMIC') {
      this.cmdRouterSvc.sendActionCmd(CMD_TARGETS.PANORAMIC_MANAGER, CMD_ACTIONS.GO_TO_PANO, {pmId: pm.id});
    } else if (pm.category === 'QR_CODE') {
      const existingPMMarker: Marker = this.placemarkMarkers.get(pm.id);
      if (existingPMMarker) {
        this.openPlacemarkImageWindow(pm.html, existingPMMarker);
      }
    } else if (pm.category !== 'ADDRESS') {
      this.placemarkPreviewService.showPlacemarkContent(pm.category, pm.placemarkUiType, pm.name, pm.settings.width, pm.settings.height, pm.url, pm.html);
    } else if (pm.category === 'ADDRESS') {
      if (pm.description && pm.description !== '') {
        this.openPlacemarkAddressWindow(pm.settings.width, pm.settings.height, pm.description, this.placemarkMarkers.get(pm.id));
      }
    }
  }

  openPlacemarkAddressWindow(width: number, height: number, description: string, marker: Marker): void {
    const percent: number = 0.50;
    const windowContent: string = '<div style=\"color: black;text-align:center; height:' + height + 'px;width:' + (width * percent) + 'px\">' + description + '</div>';
    this.removeInfoWindow();
    this.infoWindow = new Popup({offset: this.popupOffsets as Offset});
    this.infoWindow.setHTML(windowContent);
    this.infoWindow.setLngLat(marker.getLngLat());
    this.infoWindow.addTo(this.mapRef);
  }

  openPlacemarkImageWindow(content: string, marker: Marker): void {
    const windowContent: string = '<div style=\"width:100%;height:100%;text-align:center;\"><div><img src=\"' + content + '\"' + '></div></div>';
    this.removeInfoWindow();
    this.infoWindow = new Popup({offset: this.popupOffsets as Offset});
    
    this.infoWindow.setHTML(windowContent);
    this.infoWindow.setLngLat(marker.getLngLat());
    this.infoWindow.addTo(this.mapRef);
  }

  showPlacemarkContentFromMultipleMenu(pmId: string): void {
    const pmFound: IPlacemark = this.store.selectSnapshot<IPlacemark[]>((state: any) => state.StatePlacemarks.placemarks).find((pm: IPlacemark) => pm.id === pmId);
    this.showPlacemarkContent(pmFound);
  }

  handleRightClickEvent(event: Event, pm: IPlacemark, placemarkMarker: Marker): void {
    this.removeInfoWindow();
    const isSearchPlacemark = MarkerManager.getAttr(placemarkMarker, 'id').includes('SEARCH_ENGINE_RESULT');
    const closestPlacemarks: Marker[] = this.getPlacemarksInRadius(pm, isSearchPlacemark);
    !isSearchPlacemark && closestPlacemarks.push(placemarkMarker);
    if (closestPlacemarks.length === 1) {
      this.showRightClickContent(event, pm);
    } else {
      this.showDynamicPlacemarkOnHover(false, null, null);
      this.showMultiplePlacemarkMenu(pm, placemarkMarker,closestPlacemarks);
    }
  }

  public showRightClickContent(event: Event, pm: IPlacemark): void {
    this.showDynamicPlacemarkOnHover(false, null, null);

    const marker = this.placemarkMarkers.get(pm.id);
    const markerPosition = marker.getLngLat();

    const screenCoordinates: any = this.convertMapCoordinatesToScreen(markerPosition);
    this.openContextMenu.emit({x: screenCoordinates.x,
      y: screenCoordinates.y, placemarkId: pm.id});
    this.rightClickLng = markerPosition.lng;
    this.rightClickLat = markerPosition.lat;
  }

  public addSiteMarker(site: ISite): void {
    const defSite = this.activeSiteInfo ? this.activeSiteInfo.id === site.id : false;
    const existingSiteMarker: Marker = this._sitesMarkers.get(site.id);
    console.log(site.latitude)
    let siteMarker: Marker = new Marker();
    const {latitude, longitude} = MarkerManager.adjustInvalidCoordinates(site.latitude, site.longitude);
    siteMarker.setLngLat([longitude, latitude]);

    if (!existingSiteMarker) {
      siteMarker.addTo(this.mapRef);
      MarkerManager.addEventListener(siteMarker, 'dblclick', () => {
        const isSiteLoaded = this.activeSiteInfo ? this.activeSiteInfo.id === site.id : false;
        if (!isSiteLoaded) {
          this.sitesLoaderSvc.loadSite(site, SCENE_MODE.Map);
        }
      });
      MarkerManager.addEventListener(siteMarker, 'click', (e) => {
        if (this._draggablePin) {
          return;
        }
        this.removeInfoWindow();
        e.stopPropagation();
        const closeSiteMarkers: Marker[] = this.getSitesInRadius(site);
        closeSiteMarkers.push(this._sitesMarkers.get(site.id));
        if (closeSiteMarkers.length > 1) {
          const position = this.convertMapCoordinatesToScreen(siteMarker.getLngLat());
          position.y = position.y - 15;
          this.mapService.setMultipleSitesMenuOptions(closeSiteMarkers, position);
        } else {
          const isSiteLoaded = this.activeSiteInfo ? this.activeSiteInfo.id === site.id : false;
          if (isSiteLoaded) {
            this.sitesLoaderSvc.toggleSceneMode(SCENE_MODE.Facility);
          }
        }
      });
    } else {
      siteMarker = existingSiteMarker;
    }
    MarkerManager.setTitle(siteMarker, site.name);
    const urlToSiteIcon = defSite ? `${environment.baseHref}/assets/map/blue.pin.site.map.indicator.png` : `${environment.baseHref}/assets/map/red.pin.site.map.indicator.png`;
    MarkerManager.setIcon(siteMarker, urlToSiteIcon);
    MarkerManager.setZIndex(siteMarker, defSite ? Z_INDEX_CONSTS.CURRENT_SITE : Z_INDEX_CONSTS.SITE);
    MarkerManager.setAttr(siteMarker, 'id', site.id);
    this._sitesMarkers.set(site.id, siteMarker);
  }

  public createDraggableMarker(iconUrl: string, newMode: boolean, pmId?: string): void {
    if (newMode) {
      const center = this.mapRef.getCenter();
      this._draggablePin = new Marker({
        draggable: true
      }).setLngLat([center.lng, center.lat]).addTo(this.mapRef);
      
      MarkerManager.setZIndex(this._draggablePin, Z_INDEX_CONSTS.PLACEMARK + 100);
      MarkerManager.setZIndex(this._draggablePin, Z_INDEX_CONSTS.EDIT_CREATE);
      MarkerManager.setIcon(this._draggablePin, iconUrl, PLACEMARK_SIZE, PLACEMARK_SIZE);
    } else {
      this._draggablePin = this.placemarkMarkers.get(pmId);
      if (!this._draggablePin) {
        this._draggablePin = this.searchResultsMarkers.get(pmId);
      }
      MarkerManager.setZIndex(this._draggablePin, Z_INDEX_CONSTS.PLACEMARK + 100);
      this._draggablePin.setDraggable(true);
    }
    this.dialogComSvc.sendToActiveDialog({latitude: this._draggablePin.getLngLat().lat, longitude: this._draggablePin.getLngLat().lng});

    this._draggablePin.on('drag', (event: any) => {
      if (!newMode) {
        this.throttleFunction(() => {
          const placemarkMarkers: Map<string, Marker> = new Map();
          placemarkMarkers.set(pmId, this._draggablePin);
          this.updateDynamicPlacemarkProperties(placemarkMarkers);
        }, 100/30)();
      }

      this.dialogComSvc.sendToActiveDialog({latitude: event.target.getLngLat().lat, longitude: event.target.getLngLat().lng});
    });
  }

  public removeDraggableMarker(newMode: boolean): void {
    if (newMode) {
      this._draggablePin.remove();
    } else {
      this._draggablePin.setDraggable(false);
    }
    MarkerManager.setZIndex(this._draggablePin, Z_INDEX_CONSTS.PLACEMARK);
    this._draggablePin = undefined;
  }

  public removeMarker(siteId: number): void {
    const existingSiteMarker: Marker = this._sitesMarkers.get(siteId);
    if (existingSiteMarker) {
      existingSiteMarker.remove();
      this._sitesMarkers.delete(siteId);
    }
  }

  public removePMMarker(pmId: string): void {
    let existingPMMarker: Marker = this.placemarkMarkers.get(pmId);
    if (existingPMMarker) {
      existingPMMarker.remove();
      this.placemarkMarkers.delete(pmId);
      this.placemarkClusterService.placemarkRemoved(existingPMMarker);
      existingPMMarker = undefined;
      this.placemarkBasicVisibilityMap.delete(pmId);
    }
    existingPMMarker = this.searchResultsMarkers.get(pmId);
    if (existingPMMarker) {
      existingPMMarker.remove();
      existingPMMarker = undefined;
      this.searchResultsMarkers.delete(pmId);
    }
  }

  public removeSearchPMMarkers(): void {
    this.hideSearchPMMarkers();
    this.searchResultsMarkers = new Map<string, Marker>();
  }
  public hideSearchPMMarkers(): void {
    this.searchResultsMarkers.forEach((value: Marker, id: string) => {
      value.remove();
      MarkerManager.setVisible(value, true);
    });
  }
  public displaySearchPMMarkers(): void {
    this.searchResultsMarkers.forEach((value: Marker, id: string) => {
      value.addTo(this.mapRef);
      MarkerManager.setVisible(value, true);
    });
  }

  public resetZoom(): void {
    const center: LngLatLike = [this.activeSiteInfo.longitude, this.activeSiteInfo.latitude];
    this.mapRef.setCenter(center);
    this.mapRef.setZoom(DEFAULT_ZOOM_LEVEL);
  }

  goToViewpoint(lat: number, long: number, alt: number): void {
    const existingListener: any = this.actionListeners.get('goToVpListener');
    if (existingListener !== undefined) {
      this.mapRef.off('moveend', existingListener);
      this.actionListeners.delete('goToVpListener');
    }
    const center: LngLatLike = [long, lat];
    this.mapRef.setCenter(center);
    this.mapRef.setZoom(alt);

    const centerChangedListener = () => {
      this.cmdRouterSvc.sendActionCmd(CMD_TARGETS.VIEWPOINTS_PANEL, CMD_ACTIONS.REMOVE_SELECTED_VP);
    };

    this.mapRef.on('moveend', centerChangedListener);
    this.actionListeners.set('goToVpListener', centerChangedListener);
  }

  isPlacemarkClose(pm1: Marker, pm2: Marker): boolean {
    const latitude1: number = pm1.getLngLat().lat;
    const latitude2: number = pm2.getLngLat().lat;
    const longitude1: number = pm1.getLngLat().lng;
    const longitude2: number = pm2.getLngLat().lng;

    const delta1 = this.toRadians(latitude1 - latitude2);
    const delta2 = this.toRadians(longitude1 - longitude2);

    const a: number = Math.sin(delta1 / 2) * Math.sin(delta1 / 2) + Math.cos(this.toRadians(latitude1))
      * Math.cos(this.toRadians(latitude2)) * Math.sin(delta2 / 2) * Math.sin(delta2 / 2);

    const c: number = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const dist: number = this.RADIUS * c;

    const zlDist: number = this.getZoomlevelDistance();

    if (dist <= zlDist) {

      return true;
    }
    return false;
  }

  toRadians(num: number): number {
    return (Math.PI / 180) * num;
  }

  getPlacemarksInRadius(pm: IPlacemark, includeSourceMarker: boolean): Marker[] {
    const result: Marker[] = [];
    if (this.placemarkMarkers.size > 0) {
      this.placemarkMarkers.forEach((value:Marker, id: string) => {
        if (MarkerManager.getVisible(value) && (includeSourceMarker || pm.id !== id)) {
          if (this.isPlacemarkClose(this.placemarkMarkers.get(pm.id), value)) {
            result.push(value);
          }
        }
      });
    }
    return result;
  }

  getSitesInRadius(site: ISite): Marker[] {
    const result: Marker[] = [];
    if (this._sitesMarkers.size > 0) {
      this._sitesMarkers.forEach((value: Marker, id: number) => {
        if (MarkerManager.getVisible(value) && site.id !== id) {
          if (this.isPlacemarkClose(this._sitesMarkers.get(site.id), value)) {
            result.push(value);
          }
        }
      });
    }
    return result;
  }

  private onPlacemarkMarkerHover(mouseOver: boolean, pm: IPlacemark, placemarkMarker, multiple = false, positionX = null, positionY = null): void {
    if (pm.statusType == 'STATUS' && pm.showVisualization) {
      if (pm.visualizationConf.visibilityType == 'iconOnHoverValues' || multiple) {
        this.showDynamicPlacemarkOnHover(mouseOver, pm, placemarkMarker, multiple,  positionX, positionY);
      }
    }

    if (pm.statusType === 'CHECKLIST' && multiple) {
      if (mouseOver) {
        const layers: ILayer[] = this.store.selectSnapshot<ILayer[]>((state: any) => state.StateLayers.layers);
        const currentLayer = layers.find((layer: ILayer) => layer.id === pm.parentLayerId);

        let position: LngLatLike;
        if (positionX !== null && positionY !== null) {
          position = this.convertScreenCoordinatesToMap(positionX, positionY);
        } else {
          position = placemarkMarker.getLngLat();
        }
        this.showCheckPlacemarklistContent(pm, currentLayer, position, multiple);
      } else {
        this.hideChecklistPlacemarkContent(null);
      }
    }
  }

  private showDynamicPlacemarkOnHover(mouseOver, pm: IPlacemark, placemarkMarker: Marker, multiple = false, positionX = null, positionY = null) {
    if (mouseOver) {
      clearTimeout(this._dynamicPlacemarkHideTimeout);
      const placemark = this.prepareDynamicPlacemarkObj(pm, placemarkMarker);
      const position: any = this.convertMapCoordinatesToScreen(placemarkMarker.getLngLat());
      position.y = position.y - 20;
      if (multiple) {
        position.x = positionX - 10;
        position.y = positionY;
      }
      this.dynamicPlacemarkService.showDynamicPlacemarkDataOnHover(true, placemark, position);
    } else {
      this._dynamicPlacemarkHideTimeout = setTimeout(() => this.dynamicPlacemarkService.showDynamicPlacemarkDataOnHover(false, null, null), 100);
    }
  }

  private addDynamicPlacemark(pm: IPlacemark, placemarkMarker: Marker) {
    const position: any = this.convertMapCoordinatesToScreen(placemarkMarker.getLngLat());
    position.y = position.y - 7;
    position.x = position.x - 5;
    const placemark = this.prepareDynamicPlacemarkObj(pm, placemarkMarker);
    this.dynamicPlacemarkService.addPlacemark(placemark, position, this.getScaleForDynamicPlacemark());
  }

  private updateDynamicPlacemark(pm, placemarkMarker) {
    const placemark = this.prepareDynamicPlacemarkObj(pm, placemarkMarker)
    let position = null;
    if (placemark.showVisualization && ( placemark.visibilityType === 'iconAndvalues' || placemark.visibilityType === 'valuesOnCollapseIcon' )) {
      position = this.convertMapCoordinatesToScreen(placemarkMarker.getLngLat());
      position.y = position.y - 7;
      position.x = position.x - 5;
    }
    this.dynamicPlacemarkService.updatePlacemark(placemark, position);
  }

  private updateDynamicPlacemarkProperties(placemarkMarkers: Map<string, Marker>) {
    const scale = this.getScaleForDynamicPlacemark();
    placemarkMarkers.forEach( (placemarkMarker, key) => {
      const placemarkId = MarkerManager.getAttr(placemarkMarker, 'id');
      const placemark = {placemarkId: placemarkId};
      const position: any = this.convertMapCoordinatesToScreen(placemarkMarker.getLngLat());
      position.y = position.y - 7;
      position.x = position.x - 5;
      this.dynamicPlacemarkService.updatePlacemarkProperties(placemark, position, scale);
    });
  }

  private getScaleForDynamicPlacemark(): number {
    let scale = 1;
    if (this.sceneMode === SCENE_MODE.Map) {
      if (this.mapRef) {
        let zoomLevel = this.mapRef.getZoom();
        zoomLevel = zoomLevel > 5 ? 5 : zoomLevel;
        scale = zoomLevel < 1 ? 0.5 : ((zoomLevel - 1) * 0.1) + 0.6;
      }
      return scale;
    } else {
      return 0;
    }
  }

  private prepareDynamicPlacemarkObj(pm: IPlacemark, placemarkMarker: Marker) {
    return {
        name: pm.name,
        placemarkId: pm.id,
        visible: MarkerManager.getVisible(placemarkMarker),
        layerId: pm.parentLayerId,
        zoneId: pm.parentZoneId,
        showVisualization: pm.showVisualization,
        placemarkData: pm.placemarkData,
        visibilityType: pm.visualizationConf ? pm.visualizationConf.visibilityType : null
    }
  }

  private throttleFunction(func, delay) {
    let prev = 0;
    return (...args) => {
      const now = new Date().getTime();
      if (now - prev > delay) {
        prev = now;
        return func(...args);
      }
    }
  }

  private hideMenus() {
    this.mapService.setMultiplePlacemarkMenuOptions([]);
    this.mapService.setMultipleSitesMenuOptions([]);
  }

  private removeInfoWindow() {
    this.hideMenus();
    if (this.infoWindow) {
      this.infoWindow.remove();
      this.infoWindow = null;
    }
  }

  ngOnDestroy(): void {
    this.removeInfoWindow();
  }
}


class PanControl {
  private _map: any;
  private _container: HTMLDivElement;

  onAdd(map: any): HTMLDivElement {
    this._map = map;
    this._container = document.createElement('div');
    this._container.className = 'maplibregl-ctrl maplibregl-ctrl-group custom-pan-control';

    const directions = ['up', 'down', 'left', 'right'];
    const icons = {
      up: '˄',
      down: '˅',
      left: '˂',
      right: '˃'
    };
    
    // Create buttons and add click handlers
    directions.forEach(direction => {
      const button = document.createElement('button');
      button.textContent = icons[direction];
      button.className = `pan-button pan-${direction}`;
      button.onclick = () => this.pan(direction);
      this._container.appendChild(button);
    });

    return this._container;
  }

  onRemove(): void {
    this._container.parentNode?.removeChild(this._container);
    this._map = undefined;
  }

  // Pan the map based on the button clicked
  pan(direction: string): void {
    const panDistance = 200; // Adjust the pan distance as needed
    switch (direction) {
      case 'up':
        this._map.panBy([0, -panDistance]);
        break;
      case 'down':
        this._map.panBy([0, panDistance]);
        break;
      case 'left':
        this._map.panBy([-panDistance, 0]);
        break;
      case 'right':
        this._map.panBy([panDistance, 0]);
        break;
    }
  }
}